module.exports = "/shifts/shift-acceptance/shiftAcceptanceIndicatorComponent-4847c3.html";